import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';
import type { MessageKey } from 'types/LocaleMessageKey';

export interface StickyTimelineSegmentProps {
  readonly activeIndex: number;
  readonly id: string;
  readonly index: number;
  readonly sectionCount: number;
  readonly time: MessageKey;
}

const StickyTimelineSegment = ({
  activeIndex,
  id,
  index,
  sectionCount,
  time,
}: StickyTimelineSegmentProps) => {
  const t = useTranslations();
  const isActive = sectionCount - 1 - activeIndex <= index;
  const isFirst = index === 0;
  const isLast = index === sectionCount - 1;
  return (
    <div
      className={cx('flex items-center transition-opacity duration-1000', {
        'opacity-30': !isActive,
      })}
      data-cy="sticky_timeline_segment"
      data-segment-id={id}
    >
      {isFirst && (
        <>
          <div
            className="mb-1 size-3 flex-initial rounded-full bg-current"
            data-cy="sticky_timeline_start_segment_dot"
          />
          <div
            className="h-4 w-px flex-initial bg-current"
            data-cy="sticky_timeline_start_segment_dash"
          />
        </>
      )}
      <Typography
        className="my-3 tracking-wider whitespace-nowrap"
        color="inherit"
        Element="span"
        weight="bold"
      >
        {t(time)}
      </Typography>
      {isLast && (
        <>
          <div
            className="h-4 w-px flex-initial bg-current"
            data-cy="sticky_timeline_end_segment_dash"
          />
          <div
            className="mt-1 size-3 flex-initial rounded-full bg-current"
            data-cy="sticky_timeline_end_segment_dot"
          />
        </>
      )}
    </div>
  );
};

export default StickyTimelineSegment;
